<template>
  <div style="background-color: #f4fbff">
    <Header
            :leftArrow="true"
            :leftText="''"
            @leftClick="onClickLeft"></Header>
    <div class="home home-user tel-room-in">
      <div class="tel-room_inner" >
        <div class="tel-room_cam cam-off" style="height: 18rem" v-show="!cameraOpen">
          <p class="cam-off_txt">カメラがオフになっています</p>
        </div>
        <video
          class="cam-off"
          style=" object-fit: cover;border-radius: 5px;height:18rem;transform: scaleX(-1);"
          autoplay
          webkit-playsinline
          playsinline
          muted="muted"
          id="myCamera"
          v-show="cameraOpen"
        />
        <div class="tel-room_btn home_menu-area clear">
          <div :class="{ 'tel-room_btn-mic-on': mikeOpen }" class="home_menu-item tel-room_btn-mic" @click="mikeChange">
            <span class="home_menu-txt" v-show="mikeOpen">OFF</span>
            <span class="home_menu-txt" v-show="!mikeOpen">ON</span>
          </div>
          <div :class="{ 'tel-room_btn-video-on': cameraOpen }" class="home_menu-item tel-room_btn-video" @click="cameraChange">
            <span class="home_menu-txt" v-show="cameraOpen">OFF</span>
            <span class="home_menu-txt" v-show="!cameraOpen">ON</span>
          </div>
        </div>
        <van-button class="tel-room_start" @click="doCall()">発信</van-button>
      </div>
    </div>
<!--    <Footer />-->
  </div>
</template>

<script>
  import Footer from "@/components/Footer.vue";
  import Header from "@/components/Header.vue";
  import "vant/es/toast/style";
  import {Toast} from "vant";

  export default {
  data() {
    return {
      chooseItem: {
        id: "",
        name: "",
        type: "",
      },
      mikeOpen: true,
      cameraOpen: false,
      canDoCallFlg:true,
    };
  },
  components: {
    Footer,
    Header,
  },
  mounted() {
    this.id = parseInt(this.$route.query.id);
    this.chooseItem.type = this.$route.query.type
    this.chooseItem.id = this.$route.query.chooseItem_id;
    // 20231226 进入页面默认开启摄像头、麦克风
    this.cameraChange();
  },
  beforeUnmount(){
    this.stopNavigator();
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    stopNavigator() {
      if (JQuery("#myCamera").get(0) && JQuery("#myCamera").get(0) !== null &&JQuery("#myCamera").get(0).srcObject) {
        JQuery("#myCamera").get(0).srcObject.getTracks()[0].stop();
      }
    },
    async getUserMedia() {
      let videoCheck = false;
      try {
        let mediaStream = await navigator.mediaDevices.getUserMedia({audio: false, video: true,});
        if (mediaStream && mediaStream.getVideoTracks().length > 0) {
          videoCheck = true;
          JQuery("#myCamera").get(0).srcObject = mediaStream;
        }
        // 在这里处理成功获取的视频流
      } catch (error) {
        console.log("摄像头视频流获取失败:", error);
      }
      if(!videoCheck){
        Toast("カメラ権限が異常です。");
        this.cameraOpen = false;
      }
    },
    success(stream) {
      console.log(stream)
      JQuery("#myvideo").get(0).srcObject = stream;
    },
    error(error) {
      console.log(`访问用户媒体设备失败${error.name}, ${error.message}`);
    },
    mikeChange() {
      this.mikeOpen = !this.mikeOpen;
    },
    cameraChange() {
      this.cameraOpen = !this.cameraOpen;
      if(this.cameraOpen){
        this.getUserMedia()
      }else {
        this.stopNavigator()
      }
    },
    doCall() {
      if(this.canDoCallFlg){
        this.canDoCallFlg = false;
        setTimeout(() => {
          this.canDoCallFlg = true;
        }, 1000);
        this.$emit('callUser',"video",this.chooseItem,this.mikeOpen,this.cameraOpen);
      }
    },
  },
  watch: {},
  computed: {},
};
</script>

<style scoped>
/*    
   
  
    */
</style>
